import { render } from "./VSD420-OverAll.vue?vue&type=template&id=f201b32a"
import script from "./VSD420-OverAll.vue?vue&type=script&lang=js"
export * from "./VSD420-OverAll.vue?vue&type=script&lang=js"

import "./VSD420-OverAll.vue?vue&type=style&index=0&id=f201b32a&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__